import { Modal } from '@mantine/core';
import useDevice from 'hooks/useDevice';
import React from 'react';

const NotifySuccess = ({
  isSuccess,
  quantity,
  name,
  handleShowGift,
  fillInInformation = () => {},
}) => {
  const isGYCBH =
    name.toLowerCase() === 'bảo hiểm tnds xe mô tô 2 bánh dung tích trên 50 cc' ||
    name.toLowerCase() === 'bảo hiểm tnds xe ô tô không kinh doanh vận tải dưới 6 chỗ ngồi' ||
    name.toLowerCase() === 'bảo hiểm tnds xe ô tô không kinh doanh vận tải từ 6- 11 chỗ ngồi';
  const isMobile = useDevice().isMobile;
  return (
    <>
      {isMobile ? (
        <Modal
          radius='md'
          withCloseButton={false}
          opened={isSuccess}
          onClose={() => {}}
          centered
          classNames={{
            root: 'pb-9 pt-7 px-10 z-[1000000]',
            body: 'w-full ',
          }}
        >
          <img className='mx-auto mb-2 h-12 w-12' src='/icon/checked.svg' alt='' />
          <p className='text-center'>
            Đổi thành công{' '}
            <span className='font-bold'>
              {' '}
              {quantity < 10 ? '0' + quantity : quantity} {name}
            </span>
          </p>

          <div className='mx-auto mt-6 w-fit'>
            <button className='uppercaseb rounded-4px border bg-white px-8 py-3 font-averta-semibold text-13px leading-18px text-black'>
              Đóng
            </button>
            {isGYCBH ? (
              <button
                className='ml-6 rounded-4px bg-gradient-blue px-8 py-3 font-averta-semibold text-13px uppercase leading-18px text-white'
                onClick={fillInInformation}
              >
                Nhập thông tin để nhận GYCBH
              </button>
            ) : (
              <button
                className='ml-6 rounded-4px bg-gradient-blue px-8 py-3 font-averta-semibold text-13px uppercase leading-18px text-white'
                onClick={handleShowGift}
              >
                Xem quà của tôi
              </button>
            )}
          </div>
        </Modal>
      ) : (
        <div
          className={`absolute z-[20000000] transition-all ${
            isSuccess ? 'bottom-0' : '-bottom-18'
          }  flex w-full items-center justify-between bg-[#E9FFF8] px-3 py-2`}
        >
          <div className='flex'>
            <img className='mr-4 h-6 w-6' src='/icon/checked.svg' alt='' />
            <p className='line-clamp-1'>
              Đổi thành công{' '}
              <span className='font-bold'>
                {' '}
                {quantity < 10 ? '0' + quantity : quantity} {name}
              </span>
            </p>
          </div>
          {isGYCBH ? (
            <button
              className='ml-6 rounded-4px bg-009565 px-8 py-3 font-averta-semibold text-13px uppercase leading-18px text-white'
              onClick={fillInInformation}
            >
              Nhập thông tin để nhận GYCBH
            </button>
          ) : (
            <button
              onClick={handleShowGift}
              className='ml-6 rounded-4px bg-009565 px-8 py-3 font-averta-semibold text-13px uppercase leading-18px text-white'
            >
              Xem quà của tôi
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default NotifySuccess;
